import { apiInstance } from "shared/api";
import { fromErrorBody } from "./lib/auth-error";
import {
  AuthErrorBody,
  CheckBody,
  CheckResponse,
  LogoutResponse,
  MethodsBody,
  MethodsResponse,
  SendCodeBody,
  SendCodeResponse,
  StatusBody,
  StatusResponse,
} from "./types";

const JSON_HEADERS = { Accept: "application/json" };

/**
 * POST к OTP v3. Сервер может вернуть HTTP 200 с success: false
 * (например, INVALID_CODE) — такой ответ превращается в AuthError.
 */
const post = async <T extends { success: true }>(
  url: string,
  body: object,
): Promise<T> => {
  const response = await apiInstance.post<T | AuthErrorBody>(url, body, {
    headers: JSON_HEADERS,
  });
  const data = response.data;

  if (!data || data.success !== true) {
    throw fromErrorBody(
      data as AuthErrorBody | undefined,
      response.status,
      response.headers?.["retry-after"],
    );
  }

  return data as T;
};

/** Создать или продолжить сессию входа и получить каналы. */
export const getAuthMethods = (body: MethodsBody) =>
  post<MethodsResponse>("/v3/auth/methods", body);

/** Отправить код выбранным каналом. */
export const sendAuthCode = (body: SendCodeBody) =>
  post<SendCodeResponse>("/v3/auth/login", body);

/** Состояния отправок и актуальные каналы. */
export const getAuthStatus = (body: StatusBody) =>
  post<StatusResponse>("/v3/auth/status", body);

/** Проверить код и получить токен доступа. */
export const checkAuthCode = (body: CheckBody) =>
  post<CheckResponse>("/v3/auth/check", body);

/** Отзывает все токены исполнителя, включая выданные через v1. */
export const logout = () => post<LogoutResponse>("/v3/auth/logout", {});
